import { render, staticRenderFns } from "./BoaBolsa.vue?vue&type=template&id=651ff82c&scoped=true&lang=pug&"
import script from "./BoaBolsa.vue?vue&type=script&lang=js&"
export * from "./BoaBolsa.vue?vue&type=script&lang=js&"
import style0 from "./BoaBolsa.styl?vue&type=style&index=0&id=651ff82c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ff82c",
  null
  
)

export default component.exports